module.exports = __webpack_public_path__ + "static/media/td.034a25c1.svg";